import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const ResumeTextRow = ({ section, resumeEditMode, onEdit, onDelete }) => (
  <Box sx={{p:2, pb:0}}>
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        transition: "all 0.2s ease",
        '&:hover': { transform: resumeEditMode ? 'translateX(4px)' : 'none' }
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", textTransform: "capitalize" }}>
        <strong>{section.resumeTextHeading}</strong>
      </Typography>

      {resumeEditMode && (
        <Box>
          <IconButton size="small" onClick={() => onEdit(section)}>
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={() => onDelete(section)}>
            <DeleteIcon fontSize="small" color="error" />
          </IconButton>
        </Box>
      )}
    </Box>

    <Typography variant="body2" whiteSpace="pre-line" sx={{ fontSize: "1rem", mt: 1 }}>
      {section.resumeTextDetails}
    </Typography>
  </Box>
);

export default ResumeTextRow;